import { Box } from '@factorialco/deprecated-design-system'
import {
  PerformanceReviewerStrategiesStrategyEnum,
  PerformanceStrategyConfigurationInput,
} from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'

import type { Form } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel'
import { type MappedQuestionnaires } from 'modules/performance_process/hooks/useMappedQuestionnaires'
import { orderStrategies } from 'modules/performance_process/lib/reviewStrategy'

import { StrategyConfigurationItem } from './StrategyConfigurationItem'

type Props = {
  questionnaires: MappedQuestionnaires
  focusStrategy?: PerformanceReviewerStrategiesStrategyEnum | null
}

export const StrategyConfigurationsList: React.FC<Props> = ({ questionnaires, focusStrategy }) => {
  const form = useFormContext<Form>()
  const strategies = orderStrategies(Object.keys(form.values.configurationByStrategy))

  const handleWeightChange = (
    strategy: PerformanceReviewerStrategiesStrategyEnum,
    weight: number
  ) => {
    const configuration = form.values.configurationByStrategy[strategy]
    if (!configuration) {
      return
    }
    const newConfiguration: PerformanceStrategyConfigurationInput = {
      ...configuration,
      weight: configuration.reviewerStrategy === strategy ? weight : configuration.weight,
      producesScore: configuration.producesScore || weight > 0,
    }
    form.setFieldValue(`configurationByStrategy.${strategy}`, newConfiguration)
  }

  return (
    <Box gap="s12">
      {strategies.map((reviewerStrategy) => {
        const configuration = form.values.configurationByStrategy[reviewerStrategy]
        if (!configuration) {
          return null
        }
        return (
          <StrategyConfigurationItem
            key={`strategy-configuration-${reviewerStrategy}`}
            configuration={configuration}
            questionnaire={questionnaires[reviewerStrategy]}
            focusStrategy={focusStrategy}
            onChange={handleWeightChange}
          />
        )
      })}
    </Box>
  )
}
